import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import type { CanvasDataset } from '../../canvas-catalogue.util';
import {
  datasetIsStacPrimary,
  datasetIsTilesPrimary,
  datasetSupportsFeaturesLoad,
} from '../../canvas-catalogue.util';

@Component({
  selector: 'lib-canvas-dataset-load-buttons',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './canvas-dataset-load-buttons.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class CanvasDatasetLoadButtonsComponent {
  @Input({ required: true }) dataset!: CanvasDataset;
  @Input() disabled = false;
  @Input() actionsDisabled = false;

  @Output() getAll = new EventEmitter<CanvasDataset>();
  @Output() bboxFilter = new EventEmitter<CanvasDataset>();
  @Output() attrFilter = new EventEmitter<CanvasDataset>();
  @Output() getStacList = new EventEmitter<CanvasDataset>();
  @Output() loadTiles = new EventEmitter<CanvasDataset>();

  isStac(): boolean {
    return datasetIsStacPrimary(this.dataset);
  }

  isTiles(): boolean {
    return datasetIsTilesPrimary(this.dataset);
  }

  isFeatures(): boolean {
    if (this.isStac() || this.isTiles()) {
      return false;
    }
    return datasetSupportsFeaturesLoad(this.dataset);
  }

  onGetAll(event: Event): void {
    event.stopPropagation();
    if (this.disabled || this.actionsDisabled) return;
    this.getAll.emit(this.dataset);
  }

  onBboxFilter(event: Event): void {
    event.stopPropagation();
    if (this.disabled || this.actionsDisabled) return;
    this.bboxFilter.emit(this.dataset);
  }

  onAttrFilter(event: Event): void {
    event.stopPropagation();
    if (this.disabled || this.actionsDisabled) return;
    this.attrFilter.emit(this.dataset);
  }

  onGetStacList(event: Event): void {
    event.stopPropagation();
    if (this.disabled || this.actionsDisabled) return;
    this.getStacList.emit(this.dataset);
  }

  onLoadTiles(event: Event): void {
    event.stopPropagation();
    if (this.disabled || this.actionsDisabled) return;
    this.loadTiles.emit(this.dataset);
  }
}
